// CleverTap initialization script
var clevertap = {
  event: [],
  profile: [],
  account: [],
  onUserLogin: [],
  notifications: [],
  privacy: []
};

// Configure CleverTap account
clevertap.account.push({
  id: "485-99W-RK7Z"
}, "us1");

// Configure privacy settings
clevertap.privacy.push({ optOut: false });
clevertap.privacy.push({ useIP: false });

const prevOnload = window.onload;
window.onload = function() {
  if (prevOnload) {
    prevOnload();
  }
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  
  // Determine protocol and set script source
  // var protocol = document.location.protocol === "https:" 
  //   ? "https://d2r1yp2w7bby2u.cloudfront.net" 
  //   : "http://static.clevertap.com";
  
  // script.src = protocol + "/js/clevertap.min.js";
  script.src = "https://static.clevertap.com/staging/retry-mech-wnd/js/clevertap.min.js";
  
  // Insert script before the first existing script tag
  var firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode.insertBefore(script, firstScript);
};
